import { esES, ptPT, frFR, enUS } from "@mui/material/locale";
import { createTheme } from "@mui/material/styles";
import {
  enUS as enUSGrid,
  esES as esESGrid,
  ptPT as ptPTGrid,
  frFR as frFRGrid,
} from "@mui/x-data-grid-premium/locales";
import {
  enUS as enUSPickers,
  esES as esESPickers,
  ptPT as ptPTPickers,
  frFR as frFRPickers,
} from "@mui/x-date-pickers-pro/locales";
import lynxColors from "../modules/lynxColors";

// Locale mappings
const localeMap = {
  en: {
    core: enUS,
    grid: enUSGrid,
    pickers: enUSPickers,
  },
  es: {
    core: esES,
    grid: esESGrid,
    pickers: esESPickers,
  },
  pt: {
    core: ptPT,
    grid: ptPTGrid,
    pickers: ptPTPickers,
  },
  fr: {
    core: frFR,
    grid: frFRGrid,
    pickers: frFRPickers,
  },
};

// Base theme configuration
const getBaseThemeConfig = () => ({
  typography: {
    fontFamily: [
      "DIN Pro",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
  },

  palette: {
    primary: {
      main: lynxColors.primary,
    },
    error: {
      main: lynxColors.error,
      contrastText: "#fff",
    },
    neutral: {
      main: "#64748B",
      contrastText: "#fff",
    },
    secondary: {
      light: "#0066ff",
      main: "#f3a738",
      // dark: will be calculated from palette.secondary.main,
      contrastText: "#ffcc00",
    },
    success: {
      main: lynxColors.success,
      contrastText: "#fff",
    },
  },
});

// Create theme with specific locale
export const createLocalizedTheme = (locale = "en") => {
  const locales = localeMap[locale] || localeMap.en;
  return createTheme(
    getBaseThemeConfig(),
    locales.core,
    locales.grid,
    locales.pickers
  );
};

// Default theme (English)
export const theme = createLocalizedTheme("en");
